/* eslint-disable max-len */
import axios from "axios";

const secret = "72d29705-33a6-4e70-876a-c3862cfaab56";
// eslint-disable-next-line prefer-destructuring
const { REACT_APP_APP_BASE_URL: url } = process.env;

const pinzApiService = {
  async getUserDataByPhone({ firebaseId, phoneNumber }) {
    try {
      const data = JSON.stringify({
        firebaseId,
        phoneNumber,
        secret,
      });
      const response = await axios.post(
        `${url}/pub/user/findbyphonenumber/`,
        data,
      );

      return response.data;
    } catch (error) {
      return false;
    }
  },

  async getHandicapIndex({ firebaseId, phoneNumber, lastName, ghinNumber }) {
    try {
      const data = JSON.stringify({
        firebaseId,
        phoneNumber,
        lastName,
        ghinNumber,
        secret,
      });
      const response = await axios.post(`${url}/pub/user/findbyghin/`, data);

      return response.data;
    } catch (error) {
      return false;
    }
  },

  async createPinzUser({
    id,
    phone,
    displayName,
    matchId,
    teeTimeId,
    teeTimeTimestamp,
    teamId,
    venmoAccount,
  }) {
    const data = JSON.stringify({
      id,
      phone,
      displayName,
      matchId,
      teeTimeId,
      teeTimeTimestamp,
      teamId,
      venmoAccount,
      secret,
      phoneNumber: phone,
    });
    try {
      const response = await axios.post(`${url}/pub/user/firebaseuser/`, data);

      return response.status === 200;
    } catch (error) {
      return false;
    }
  },

  async updateVenmoAcoount({ phoneNumber, venmoAccount }) {
    const data = JSON.stringify({
      phoneNumber,
      venmoAccount,
      secret,
    });

    try {
      const response = await axios.patch(`${url}/pub/user/firebaseuser/`, data);

      return response.data;
    } catch (error) {
      return false;
    }
  },

  /**
   * Get tees by courseId.
   * @param {*} courseId
   * @param {*} gender
   * @returns course with tees
   */
  async getTeesByCourseId({ courseId, gender }) {
    const data = JSON.stringify({
      courseId,
      gender,
      secret,
    });

    try {
      const response = await axios.post(`${url}/pub/course/tees`, data);
      return response.data;
    } catch (error) {
      return false;
    }
  },
};

export default pinzApiService;
